import { iButtonDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/Button/Button';
import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { nameof } from 'ts-simple-nameof/src/nameof';
import { ValidationInfoDisplayOptions } from '../../../templates/dataGrid/column/validation-info-column-template/ValidationInfo';
import { OrderForwardStepItem } from './OrderForward';

export const orderStepsForwardGridId = 'OrderForward.orderStepsForwardGrid';
const orderStepsForwardGridOptions: iDataGridDisplayOptions = {
    id: orderStepsForwardGridId,
    columnAutoWidth: true,
    showBorders: false,
    columns: [
        {
            dataField: nameof<OrderForwardStepItem>((c) => c.id),
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderForwardStepItem>((c) => c.location),
            caption: 't~OrderForward:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            caption: 't~OrderForward:column.plannedStartDate',
            width: '150px',
            cellTemplate: 'OrderForwardPlannedStartDateColumn',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderForwardStepItem>((c) => c.type),
            caption: 't~OrderForward:column.type',
            width: '120px',
            cellTemplate: 'ForwardStepType',
            allowSorting: false,
        },
        {
            dataField: nameof<OrderForwardStepItem>((c) => c.payload!.carrierCount),
            caption: 't~OrderForward:column.carrierCount',
            width: '80px',
            dataType: 'number',
            allowSorting: false,
        },
        {
            dataField: 'error',
            cellTemplate: 'ValidationInfoColumn',
            caption: '',
            width: '32px',
        },
    ],
};
propsStore.insert(orderStepsForwardGridOptions);

export const orderStepsForwardAddNewUnloadPlaceId =
    'OrderForward.orderStepsForwardAddNewUnloadPlace';
const orderStepsForwardAddNewUnloadPlaceOptions: iButtonDisplayOptions = {
    id: orderStepsForwardAddNewUnloadPlaceId,
    //
    icon: 'plus',
    type: 'success',
    stylingMode: 'text',
    //
    text: 't~OrderForward.addNewUnloadPlace',
};
propsStore.insert(orderStepsForwardAddNewUnloadPlaceOptions);

export const orderStepsForwardGridErrorInfoColumnId =
    'OrderForward.orderStepsForwardGrid.column.error';
const orderStepsForwardGridErrorInfoColumnOptions: ValidationInfoDisplayOptions = {
    id: orderStepsForwardGridErrorInfoColumnId,
    validationResult: 'v~validationResult' as any,
    orderErrorInfoDisplayOptions: {
        hideEditButton: true,
        hideOnHoverEnd: true,
        hideTitle: true,
    },
};
propsStore.insert(orderStepsForwardGridErrorInfoColumnOptions);
